import { STORY_SCENE_IDS } from "../../src/game/story";
import { NO_CONSUMABLES } from "../../src/game/Consumable";
import { GameState } from "../../src/game/GameState";
import { ALL_ARTICLE_IDS } from "../../src/game/manual";
import { STARTER_SKILLS } from "../../src/game/Skill";
import { MachineState } from "../../src/game/Machine";

function idleMachine(
  machineTypeId: MachineState["machineTypeId"],
  position: [number, number],
  selectedOperationId: string,
  selectedParameters?: MachineState["selectedParameters"],
): MachineState {
  return {
    machineTypeId,
    position,
    rotation: 0,
    inputMaterials: [],
    processingMaterials: [],
    outputMaterials: [],
    tools: [],
    selectedOperationId,
    selectedParameters,
    operationProgress: {
      status: "notStarted",
      phaseIndex: 0,
      minutesRemaining: 0,
    },
  };
}

/**
 * Everything needed to run the cutting board chain WITHOUT a planer:
 * workspace and sales table (operation cells at [1,3], [3,3]), the player at
 * the workspace with five smooth maple strips — two in the arms, three
 * already staged in the bench's bay (more than one armful travels as the
 * hands allow) — a random orbit sander carried in hand, ready to mount,
 * and commission 6 active. Proves machines buy time, not access.
 */
const strips = Array.from({ length: 5 }, (_, i) => ({
  id: `test-strip-${i}`,
  type: "board" as const,
  species: "maple" as const,
  length: 24,
  width: 2 as const,
  thickness: 4 as const,
  surface: "smooth" as const,
  jointedFaces: 2 as const,
  jointedEdges: 2 as const,
}));

export const cuttingBoardShop: GameState = {
  minute: 0,
  day: 1,
  dayStartMinute: 0,
  money: 100,
  reputation: 17,
  consumables: NO_CONSUMABLES,
  // Four bars on the rack: exactly what one panel glue-up ties up.
  clamps: 4,
  materialPiles: [],
  player: {
    name: "Player",
    position: [1, 4], // the workspace's operation cell
    direction: 0,
    inventory: [
      ...strips.slice(0, 2),
      { id: "test-sander", type: "tool", toolId: "randomOrbitSander" },
      { id: "test-finishing-kit", type: "tool", toolId: "finishingKit" },
    ],
    away: null,
  },
  machines: [
    {
      ...idleMachine("workspace", [1, 2], "dismantlePallet"),
      inputMaterials: strips.slice(2),
    },
  ],
  machineCrates: [],
  truck: { bed: [], crates: [] },
  storage: {
    upgrades: [],
  },
  shopInfo: {
    name: "One Car Garage",
    electricity: 120,
    size: [12, 16],
    materialDropoffPosition: [10, 13],
    entrancePosition: [6, 15],
  },
  progression: {
    tutorials: {
      opening: { step: 0, dismissed: true },
      firstNight: { step: 1, dismissed: false },
      dust: { step: 0, dismissed: false },
    },
    storeUnlocked: true,
    standUnlocked: true,
    // A staged shop is past the opening: every scene has played
    story: { scenesPlayed: [...STORY_SCENE_IDS] },
    lumberyardUnlocked: true,
    salesCompleted: 2,
    // Lets specs use the speed keys to fast-forward through glue cures
    sweepingUnlocked: false,
    unlockedArticles: ALL_ARTICLE_IDS,
    readArticles: ALL_ARTICLE_IDS,
    xp: 0,
    skillPoints: 0,
    unlockedSkills: STARTER_SKILLS,
  },
  stand: [],
  standSetUp: true,
  customers: [],
  dust: {},
  shopVac: null,
  broomOwned: true,
  broomPosition: [0, 0],
  dustpan: {},
};
